import { useSelector } from 'react-redux'
// modules
import { styled, Typography } from '@mui/material'
import { t } from '$i18n'
import { fileDropZoneIsOpenView } from '$comp/_app/components/chat/components/body/components/fileDropZone/fileDropZone.reducer'

const DropZoneBackground = styled('div')`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  pointer-events: none;
`

const DropZoneBox = styled('div')`
  width: 60%;
  height: 50%;
  border-radius: 20px;
  border: 3px dashed #ffffff88;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 20px;
`

const DropTypography = styled(Typography)`
  color: #ffffffbf;
  font-size: 30px;
  line-height: 1.5;
  text-align: center;
`

export function FileDropZone() {
  const isOpen = useSelector(fileDropZoneIsOpenView)
  if (!isOpen) return null

  return (
    <DropZoneBackground>
      <DropZoneBox>
        <DropTypography>{t('chat.dropHereToSend')}</DropTypography>
      </DropZoneBox>
    </DropZoneBackground>
  )
}

FileDropZone.defaultProps = {
  isOpen: false,
}
